import React from 'react';

export default function Logo({ className = '', variant = 'dark', size = 'md' }) {
  const heights = { sm: 'h-10', md: 'h-14', lg: 'h-16', xl: 'h-24' };
  const filter = variant === 'light' ? 'brightness(0) invert(1)' : 'none';
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/inpace_logo.png"
        alt="Inpace Power"
        className={`${heights[size] || heights.md} w-auto`}
        style={{ filter }}
        data-testid="site-logo"
      />
    </div>
  );
}
